import React, { FC, useState, useEffect, useCallback } from 'react';
import { Title, useNotify, useRefresh, useTranslate, Notification, useDataProvider, warning, useCreate, minLength } from 'react-admin';
import { Button, createStyles, Divider, Grid, makeStyles, TextField, Theme, Tooltip, FormControlLabel, Checkbox, Box, MenuItem, FormHelperText } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useForm, SubmitHandler, useController } from "react-hook-form";

type Inputs = {
    username: string,
    password: string,
    privilege: string,
    company: string,
};

const Create: FC = () => {

    const notify = useNotify();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();
    const history = useHistory();

    const [username, setUsername] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [privilege, setPrivilege] = useState<string>("")

    const { register, handleSubmit, control, watch, setValue, formState: { errors, isDirty } } = useForm<Inputs>();
    const OnSubmit = () => {

        const created = {
            username: username,
            password: password,
            privilege: "admin",
            // company: company,
        }

        dataProvider.create(
            'users',
            {
                data: created
            },
        ).then((response: any) => {
            notify('User was successfully invited');
            history.push("/users");
        }).catch((error: any) => {
            notify(error.message, { type: "warning" });
        })
    }

    return (
        <Box sx={{ pl: 5, pt: 12 }}>
            <Title title="Invite User" />
            <Box>
                <form onSubmit={handleSubmit(OnSubmit)}>
                    <Grid container spacing={1}>
                        <Grid item md={2}>
                            <TextField
                                id="username"
                                label="Username*"
                                placeholder="Enter Username"
                                InputLabelProps={{ shrink: true, required: true }}
                                onChange={(e: any) => { setUsername(e.target.value) }}
                                variant="outlined"
                                fullWidth
                                type="email"
                                required
                            />
                        </Grid>
                        <Grid item md={2}>
                            <TextField
                                id="password"
                                label="Password*"
                                placeholder="Enter Password"
                                InputLabelProps={{ shrink: true, required: true }}
                                onChange={(e: any) => { setPassword(e.target.value) }}
                                variant="outlined"
                                fullWidth
                                type="text"
                            />
                        </Grid>
                    </Grid>
                    <Box sx={{ pb: 3 }}></Box>
                    <Grid container spacing={2}>
                        <Grid item xs={5} md={2}>
                            <TextField
                                id="Privilege"
                                select
                                label="Privilege"
                                variant="outlined"
                                defaultValue="Admin"
                                // onChange={(e: any) => { setPrivilege(e.target.value) }}
                                fullWidth
                            >
                                <MenuItem value="Admin">Admin</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                    <Box sx={{ p: 4 }}>
                        <Divider />
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item md={3}>
                            <Button
                                type="button"
                                onClick={handleSubmit(OnSubmit)}
                                variant="contained"
                                color="primary"
                                size="large"
                                disabled={username == "" || password == "" ? true : false}
                            >
                                Add
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </Box>
    )
}

export default Create;